<!-- Define templates. -->
<ng-container>
    <ng-template #notificationPreviewTitle><b>{{this.NotificationPreviewTitle}}</b></ng-template>
    <ng-template #notificationPreviewContent>{{this.NotificationPreviewContent}}</ng-template>
</ng-container>

<!-- Define this component's form. -->
<ng-container *ngIf="this.FormGroup != null">
    <form [formGroup]="this.FormGroup">
        <!--
            TO DO -- create form controls:

                1. Event type dropdown;
                2. Target date picker + target time picker;
                3. Target workflow state dropdown;
                4. Auto-set workflow state checkbox;
                5. Send notification radio button controls;
                6. Notification template dropdown.
            -->
        <!-- Event type dropdown. -->
        <div class="site-event-div">
            <mat-form-field appearance="fill">
                <mat-label>Site Event</mat-label>
                <mat-select [formControl]="this.EventTypeFormControl"
                            class="set-left-align">
                    <mat-option *ngFor="let siteEvent of this.SiteEventNames; let iEventType=index"
                                [value]="iEventType">
                        {{siteEvent}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <span class="margin-left-20px">{{this.SiteEventDescription}}</span>

            <div class="flex-take-up-space-div"></div>

            <!-- Note:  no target workflow state dropdown. -->
            <!-- Auto-set workflow state checkbox. -->
            <mat-checkbox [formControl]="this.AutoSetWorkflowStateFormControl"
                          class="margin-left-20px"
                          matTooltip="{{this.AutoSetWorkflowStateTooltip}}"
                          [matTooltipPosition]="this.TooltipPosition">
                Auto-set Workflow State?
            </mat-checkbox>
        </div>

        <!-- Target date picker. -->
        <div>
            <mat-form-field appearance="fill">
                <mat-label>Target Date</mat-label>
                <input matInput
                       [formControl]="this.TargetDateFormControl"
                       [matDatepicker]="milestoneDatePicker"
                       [min]="this.MinMilestoneDate"
                       [max]="this.MaxMilestoneDate">
                <mat-datepicker-toggle matSuffix
                                       [for]="milestoneDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #milestoneDatePicker></mat-datepicker>
            </mat-form-field>

            <!-- Target time (will replace will a Material date and time picker .-->
            <mat-form-field appearance="fill"
                            [floatLabel]="'always'"
                            class="margin-left-20px">
                <mat-label class="set-left-align">Target Time</mat-label>

                <mat-select [formControl]="this.TargetTimeFormControl"
                            class="set-left-align">
                    <mat-option *ngFor="let targetTime of this.MilestoneTimes; let iTargetTime=index"
                                [value]="targetTime.hoursOffset">
                        {{targetTime.displayTime}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Send notification radio button controls. -->
        <div class="send-notification-div">
            <span>Send notification?</span>

            <mat-radio-group [formControl]="this.SendNotificationFormControl"
                             class="set-left-align">
                <mat-radio-button value="yes"
                                  class="margin-left-20px">
                    'Yes'
                </mat-radio-button>
                <mat-radio-button value="no"
                                  class="margin-left-20px">
                    'No'
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <!-- Notification template dropdown. -->
        <!-- Note:  not allowing notification template selection at this time. -->
        <!-- Notification preview icon. -->
        <div>
            <span>Notification preview:</span>

            <button mat-stroked-button
                    color="accent"
                    class="margin-left-20px"
                    (click)="this.notificationPreviewClicked()"
                    #notificationPreviewPopover
                    [popoverTitle]="notificationPreviewTitle"
                    [ngbPopover]="notificationPreviewContent"
                    triggers="manual"
                    [container]="'body'"
                    [placement]="'right'">
                Generate ...
            </button>
            <button mat-stroked-button
                    color="accent"
                    class="margin-left-20px"
                    [disabled]="this.CopyPreviewToClipboardButtonDisabled"
                    (click)="this.copyNotificationPreviewToClipboard()">
                Copy
            </button>
            <span class="notification-preview-status-span">{{this.NotificationPreviewStatus}}</span>

            <!-- Notification preview popover: -->
            <!--
            <div #notificationPreviewPopover
                 [popoverTitle]="notificationPreviewTitle"
                 [ngbPopover]="notificationPreviewContent"
                 triggers="manual"
                 [container]="'body'"
                 [placement]="'right'"></div>
                -->
        </div>

    </form>
</ng-container>
